import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ContentCopy, Link } from '@mui/icons-material';
import { Button, InputAdornment, TextField } from '@mui/material';
import copy from 'copy-to-clipboard';

import {
  inquiriesInquiryToShareSelector,
  inquiriesShareUrlSelector,
} from '@store/features/inquiries/share/selectors';
import handleToast from '@utils/handleToast';

import './style.scss';

const GeneratedLink: FC = () => {
  const { t } = useTranslation();

  const shortUrl = useSelector(inquiriesShareUrlSelector);
  const inquiryToShare = useSelector(inquiriesInquiryToShareSelector);

  const handleCopy = useCallback(() => {
    shortUrl && copy(shortUrl);
    const text = inquiryToShare?.isSupplementary
      ? t('shareResponse.copiedToClipboard')
      : t('shareResponse.medicationCopiedToClipboard');
    handleToast('info', text);
  }, [t, shortUrl, inquiryToShare]);

  return (
    <div className="generated-link">
      <TextField
        className="generated-link__text-field"
        variant="filled"
        label={
          inquiryToShare?.isSupplementary
            ? t('shareResponse.linkLabel')
            : t('shareResponse.linkMedicationLabel')
        }
        value={shortUrl}
        InputProps={{
          startAdornment: (
            <InputAdornment className="generated-link__input-icon" position="start">
              <Link color="inherit" />
            </InputAdornment>
          ),
        }}
      />

      <Button
        className="generated-link__button"
        variant="text"
        color="primary"
        onClick={handleCopy}
      >
        <ContentCopy />
        &nbsp;&nbsp;{t('shareResponse.copyLink')}
      </Button>
    </div>
  );
};

export default GeneratedLink;
